(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24448],{

/***/ 24448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ StandAloneImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43235);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88737);
/* harmony import */ var _page_builder_utils_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42001);




function StandAloneImage({ props ={}  }) {
    const domainContext = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__/* .useDomainContext */ .w)();
    const { tagIcon , tagLabel , showTagIcon  } = props;
    // Helper function to get dynamic image
    const getDynamicImage = ()=>{
        // If no items or no dynamicImageBasedOnPath, return the default image
        if (!props.items || !props.dynamicImageBasedOnPath) {
            return props.image;
        }
        // Parse the path from dynamicImageBasedOnPath (e.g., "visitDetails.stateCode")
        const pathParts = props.dynamicImageBasedOnPath.trim().split(".").map((part)=>part.trim());
        // Navigate through the domainContext to get the value
        let context = domainContext;
        for (const part of pathParts){
            if (context && typeof context === "object" && part in context) {
                context = context[part];
            } else {
                // Path not found, fallback to default image
                return props.image;
            }
        }
        // If we got a string value (e.g., state code), find matching item
        if (typeof context === "string") {
            const contextValue = context;
            const matchedItem = props.items.find((item)=>item.title?.toUpperCase() === contextValue?.toUpperCase());
            if (matchedItem?.image) {
                return matchedItem.image;
            }
        }
        // Fallback to default image
        return props.image;
    };
    const dynamicImage = getDynamicImage();
    // Determine if we have a valid image source to prevent errors
    if (!dynamicImage) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["image-container"]),
        children: [
            (tagIcon || tagLabel) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().tag),
                children: [
                    showTagIcon && tagIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: tagIcon,
                        alt: tagLabel || "Tag icon",
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().tagIcon)
                    }),
                    tagLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().tagLabel),
                        children: tagLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_builder_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .ResponsiveImageRenderer */ .vO, {
                image: dynamicImage,
                alt: props.imageAlt
            })
        ]
    });
}


/***/ }),

/***/ 43235:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image-container":"styles_image-container__qvX7d","tag":"styles_tag__N7G8Q","tagIcon":"styles_tagIcon__ru3cQ","tagLabel":"styles_tagLabel__Hld7S"};

/***/ })

}]);